<template>
  <div>
    <tool-bar pageTitle="AutoHedge">
        <div class="d-flex align-center justify-center">
        <div style="gap: 1.5rem" class="ml-5 d-flex align-center">
          <h4 style="color: white">{{ clock }}</h4>
          <div class="pa-2 rounded-lg" style="background: #ffb00f; color: black">
            LATAM-FX-01
          </div>
          <div>{{ $t('autoHedge.net') }}: -$2.4M</div>
          <div style="color:#00ff88">{{ $t('autoHedge.sessionPnl') }}: +$87.2K</div>
        </div>
        </div>
    </tool-bar>
    <section v-if="!handleBlur" class="section-hedge">
      <v-container fluid>
        <v-row>
          <!--risk snapshot and montecarlos stress-->
          <v-col cols="5" class="d-flex flex-column">
            <risk-snapshot
              :averageDealPriceBid="averageDealPriceBid"
              :currentMarketPriceAsk="currentMarketPriceAsk"
              :currentMarketPriceBid="currentMarketPriceBid"
              :averageDealPriceAsk="averageDealPriceAsk"
              :currentMarketPrice="currentMarketPrice"
              :averageDealPrice="averageDealPrice"
              @new-log-entry="addLogEntry"
            ></risk-snapshot>
          </v-col>
          <v-col cols="7">
            <deal-order-flow
              :averageDealPriceBid="averageDealPriceBid"
              :currentMarketPriceAsk="currentMarketPriceAsk"
              :currentMarketPriceBid="currentMarketPriceBid"
              :averageDealPriceAsk="averageDealPriceAsk"
              :currentMarketPrice="currentMarketPrice"
              :averageDealPrice="averageDealPrice"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5">
            <monte-carlo></monte-carlo>
          </v-col>

          <v-col cols="7">
          <off-set-log :entries="logEntries"></off-set-log>
          </v-col>
        </v-row>
      </v-container>
      <!-- TODO-->
    </section>
    <div v-else>
      <img src="../assets/blur_imgs/blur5.png" :alt="$t('extras.blurredImageLockedAlt')">
    </div>
  </div>
</template>
<script>
import { useCoreStore } from "@/store/coreStore";
import ToolBar from "../components/layout/ToolBar.vue";
import DealOrderFlow from "../components/AutoHedge/components/DealOrderFlow.vue";
import RiskSnapshot from "../components/AutoHedge/components/RiskSnapshot.vue";
import MonteCarlo from "@/components/AutoHedge/components/MonteCarlo.vue";
import OffSetLog from "@/components/AutoHedge/components/OffSetLog.vue";
import { mapStores } from "pinia";
export default {
  name:"Auto.Hedge",
  components: {
    ToolBar,
    DealOrderFlow,
    RiskSnapshot,
    MonteCarlo,
    OffSetLog,
  },
  data() {
    return {
      currentMarketPriceAsk: 5.0447,
      currentMarketPriceBid: 5.0443,
      averageDealPriceBid: 5.0418,
      currentMarketPrice: 5.0445,
      averageDealPrice: 5.042,
      averageDealPriceAsk: 5.0569,
      logEntries: [],
      clock:"",
    };
  },
  mounted() {
    this.updateClock();
    setInterval(this.updateClock, 1000);
  },
  methods: {
    addLogEntry(entry) {
      this.logEntries.unshift(entry);
    },
    updateClock() {
      const hours = new Date().getHours().toString().padStart(2, "0");
      const min = new Date().getMinutes().toString().padStart(2, "0");
      const seconds = new Date().getSeconds().toString().padStart(2, "0");
      this.clock = `${hours}: ${min}: ${seconds} BRT`;
    },
  },
  computed:{
    ...mapStores(useCoreStore),
    handleBlur()
    {
      return this.coreStore.evaluateBlur(this.$options.name)
    },
  }

};
</script>

<style scoped>
.section-hedge{
  margin-top: 9rem;
}
</style>